export default __webpack_public_path__ + "media/images/svg/icon_logo-b706f64444b02224aa40c2a5467469bf.svg";